import React from "react";

const BlogPostCard = ({ image, title, url }) => {
  const getLastPartOfUrl = (url) => {
    const parts = url.split("/");
    return "/blog/" + parts[parts.length - 1];
  };

  return (
    <a href={getLastPartOfUrl(url)}>
      <div className="flex flex-col items-center justify-center rounded border-2 border-inherit p-1">
        <img className="w-auto h-48 object-cover" src={image} alt={title} />
        <h3 className="text-lg font-semibold mt-4">{title}</h3>
      </div>
    </a>
  );
};

export default BlogPostCard;
